import axios from "axios";
export default {
    data() {
        return {
            costCenter: [],
            peruntukan: [],
            treeExpandedKeys: [],
            anggaran: {
                peruntukan_id: "",
                anggaran_id: "",
                id_kas: "",
                modalvalue: undefined,
                path: "",
                limit: 0,
                tree: [],
                treeModal: [],
                searchValue: "",
                loadingtree: false,
            },
            selectedTree: [],
            EnCommission: true,
            Viwithout_note: true,
        }
    },
    beforeCreate() {
        this.formCollective = this.$form.createForm(this);
    },
    methods: {
        handleJenisAnggaran(e) {
            this.formCollective.resetFields([
                "cost_center",
                "peruntukan",
                "sub_peruntukan",
                "kode_anggaran",
            ]);
            const filter = this.getCostCenter.filter(
                (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
            );

            this.costCenter = filter;
            this.subPeruntukan = [];
            this.peruntukan = [];
            this.anggaran.tree = [];
            this.anggaran.treeModal = [];
        },
        handleCost(e) {
            this.formCollective.resetFields(["peruntukan", "sub_peruntukan", "kode_anggaran"]);
            this.subPeruntukan = [];
            this.anggaran.tree = [];
            this.anggaran.treeModal = [];
            const peruntukan = this.getPeruntukan.filter(
                (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
            );
            this.peruntukan = peruntukan;

            this.anggaran.anggaran_id = e;
        },
        handlePeruntukan(e) {
            this.formCollective.resetFields(["sub_peruntukan", "kode_anggaran"]);
            this.anggaran.peruntukan_id = e;
            this.anggaran.tree = [];
            this.anggaran.treeModal = [];
            const filter = this.getSubPeruntukan.filter(
                (obj) => obj.peruntukan_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
            );
            this.subPeruntukan = filter;
            this.getTreeAnggaran();
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },
        getParent(root) {
            let data = [];
            root.forEach((item) => {
                if (item.key) {
                    data.push(item.key);
                }

                if (item.children.length > 0) {
                    item.children.forEach((d) => {
                        data.push(d.key);
                    });
                }
            });
            return data;
        },
        getTreeAnggaran() {
            this.anggaran.loadingtree = true;
            let dataParams =
                this.mode == "Edit" && this.type == "revised"
                    ? {
                        anggaran_id: this.anggaran.anggaran_id,
                        tlc: this.getAuth.username,
                        peruntukan_id: this.anggaran.peruntukan_id,
                        id_klaim: this.id_klaim,
                    }
                    : {
                        anggaran_id: this.anggaran.anggaran_id,
                        tlc: this.getAuth.username,
                        peruntukan_id: this.anggaran.peruntukan_id,
                    };
            if (dataParams.peruntukan_id) {
                axios({
                    method: "get",
                    url: this.$serviceUrl + "klaim_cc/tree_anggaran",
                    params: dataParams,
                    auth: {
                        username: this.getAuth.username,
                        password: this.getAuth.password,
                    },
                    headers: {
                        "X-API-KEY": this.getAuth.apikey,
                    },
                })
                    .then((response) => {
                        this.anggaran.tree = response.data.tree;
                        this.anggaran.treeModal = [
                            ...this.anggaran.treeModal,
                            response.data.tree[0],
                        ];
                        let arr = this.dataList.filter((item) => item.kredit !== "");
                        this.recountingAnggaran(arr);
                        this.anggaran.loadingtree = false;

                        this.treeExpandedKeys = this.getParent(response.data.tree);
                    })
                    .catch((err) => {
                        this.anggaran.loadingtree = false;
                        console.log(err);
                        let responses = Object.assign({}, err.response);
                        this.displayMessageValue("error", responses);
                    });
            }
        },
        recountingAnggaran(arr) {
            arr = arr.filter((obj) => obj.path !== "");
            if (arr.length > 0) {
                //restore nominal ke origin
                arr.forEach((elm) => {
                    if (elm.path) {
                        let ObjVal = elm.path.split(";");
                        let path1 = "";
                        let path2 = "";
                        let path3 = "";
                        let trigerpath = true;
                        let tempTree = this.anggaran.tree;
                        ObjVal.forEach((element) => {
                            if (path1 == "") {
                                path1 += "tempTree[" + element + "]";
                                path3 = path1;
                            } else {
                                path3 = path1 + ".children";
                                path1 += ".children[" + element + "]";
                            }
                            if (trigerpath) {
                                if (!eval(path3)) {
                                    trigerpath = false;
                                    return;
                                } else {
                                    if (!eval(path1)) {
                                        trigerpath = false;
                                        return;
                                    }
                                }
                            }
                        });

                        if (trigerpath) {
                            path2 = eval(path1 + ".origin_rekap");
                            eval(path1 + ".rekap=" + path2);
                            //eval(path1+".disabled=false")
                        }
                    }
                });
                //menghitung nominal dengan acuan nominal origin
                arr.forEach((elem) => {
                    if (elem.path) {
                        let ObjVal = elem.path.split(";");
                        let path = "";
                        let tpath = "";
                        let trigerpath = true;
                        let tempTree = this.anggaran.tree;
                        ObjVal.forEach((element) => {
                            if (path == "") {
                                path += "tempTree[" + element + "]";
                                tpath = path;
                            } else {
                                tpath = path + ".children";
                                path += ".children[" + element + "]";
                            }
                            if (trigerpath) {
                                if (!eval(tpath)) {
                                    trigerpath = false;
                                    return;
                                } else {
                                    if (!eval(path)) {
                                        trigerpath = false;
                                        return;
                                    }
                                }
                            }
                        });
                        if (trigerpath) {
                            let kd_anggrn = eval(path + ".kode_anggaran");
                            if (kd_anggrn == elem.kode_anggaran) {
                                let oldVal = eval(path + ".rekap");
                                let num = oldVal - parseFloat(elem.kredit);
                                let exe = path + ".rekap=" + num;
                                eval(exe);
                                if (num <= 0) {
                                    eval(path + ".disabled=true");
                                } else {
                                    eval(path + ".disabled=false");
                                }
                            }
                        }
                        this.anggaran.tree = tempTree;
                    }
                });
            }
        },
        handlechoiceCost(value, record) {
            this.anggaran.limit = record.dataRef.rekap;
            this.anggaran.path = record.dataRef.path;
            let isKomisi = this.getCommisionSts(this.anggaran.path);
            if(isKomisi){
                this.EnCommission = true;
                this.Viwithout_note = false;
                this.$nextTick(function () {
                this.formCollective.setFieldsValue({
                    iscommision: "1",
                    without_note: "0",
                });
                });
            }else{
                this.EnCommission = false;
                this.Viwithout_note = true;
                this.$nextTick(function () {
                this.formCollective.setFieldsValue({
                    iscommision: "0",
                    without_note: "0",
                });
                });
            }
            // this.modalanggaran.visible = false;
        },
        filterTreeNode(input, option) {
            return (
                option.data.props.texttitle == undefined ||
                (option.data.props.texttitle ? option.data.props.texttitle : "")
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0 ||
                (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },
        handleCheck(e) {
            const item = e.target.value;
            this.selectedTree.indexOf(item) == -1 ? this.selectedTree.push(item) : this.selectedTree.splice(this.selectedTree.indexOf(item), 1)
        },
        handleSet() {
            this.formCollective.validateFields((err, values) => {
                if (err) {
                    this.newLoading = false;
                    this.pageLoading = false;
                    this.displayMessage("form-warning");
                    return;
                }

                let kd = values.kode_anggaran.split(";");

                this.setloading = true
                axios({
                    method: "put",
                    url: this.type == 'revised' ?  this.$serviceUrl + "klaim_cc/revisi_klaim_cc_dtl_kolektif" : this.$serviceUrl + "klaim_cc/klaim_cc_dtl_draft_kolektif",
                    processData: false,
                    data: {
                        "id_klaim": this.id_klaim,
                        "cost_center": values.cost_center,
                        "peruntukan": values.peruntukan,
                        "anggaran_dtl_val_id": kd[kd.length - 1],
                        "path": this.anggaran.path,
                        "selected_item": this.selectedTree,
                        "iscommision": values.iscommision,
                        "without_note": "1",
                        "pipeline" : values.pipeline_id,
                        "activity" : values.activity,
                        "activity_type" : values.activity_type,
                    },
                    auth: {
                        username: this.getAuth.username,
                        password: this.getAuth.password,
                    },
                    headers: {
                        "Content-Type": "application/json",
                        "X-API-KEY": this.getAuth.apikey,
                    },
                }).then(response => {
                    this.fetchPemakaian();
                    // this.reset();
                    this.formCollective.setFieldsValue({
                        iscommision: "0",
                        without_note: "0",
                        kode_anggaran: null,
                    });
                    this.setloading = false
                    this.displayMessage("success-save")
                }).catch(err => {
                    this.displayMessageValue("error", err.response.data.message)
                });
            })
        },
        reset() {
            this.costCenter = [],
                this.peruntukan = [],
                this.treeExpandedKeys = [],
                this.anggaran = {
                    peruntukan_id: "",
                    anggaran_id: "",
                    id_kas: "",
                    modalvalue: undefined,
                    path: "",
                    limit: 0,
                    tree: [],
                    treeModal: [],
                    searchValue: "",
                    loadingtree: false,
                },
                this.selectedTree = [],
                this.formCollective.resetFields();
        },
        handleCloseCollective() {
            this.isCollective = false;
        },
        onCollective() {
            this.EnCommission = true;
            this.Viwithout_note = true;
            this.isCollective = true;
            this.$nextTick(function () {
                this.formCollective.resetFields();
                this.formCollective.setFieldsValue({
                    iscommision: "1",
                    without_note: "0",
                    jenis_anggaran: this.collectData.informasi.jenis_anggaran,
                    cost_center: this.collectData.informasi.cost_center,
                    peruntukan: this.collectData.informasi.peruntukan,
                });
            })
            this.handleJenisAnggaran(this.collectData.informasi.jenis_anggaran)
            this.handleCost(this.collectData.informasi.cost_center)
            this.handlePeruntukan(this.collectData.informasi.peruntukan)

            if(this.checkAllCollective){
                this.checkAllCollective = false
                let temcheck = {
                    target:{checked: false}
                }
                this.onCheckAllChange(temcheck)
            }
        },
        getCommisionSts(val){
            let kdAnggrn = val.split(";");
            let text = "";
            for (let i = 0; i < (kdAnggrn.length-1); i++) {
                if (i==0){
                text="this.anggaran.tree[0]";
                }else{
                text = text+".children["+kdAnggrn[i]+"]";
                }
            }
            text = eval(text+".title");
            let sts = false;
            if(text.toLowerCase().includes("komisi"))
                sts = true;
            return sts;
        },
    }
}